import * as React from "react"
import BroadcastChannel from "broadcast-channel"

function useSyncedReducer<R extends React.Reducer<any, any>>(
	channel: BroadcastChannel<React.ReducerAction<R>>,
	reducer: R,
	initState: React.ReducerState<R>
) {
	const [state, mainDispatcher] = React.useReducer(reducer, initState)

	channel.onmessage = mainDispatcher

	const dispatch = React.useCallback(
		(action: React.ReducerAction<R>) => {
			channel.postMessage(action)
			mainDispatcher(action)
		},
		[channel, mainDispatcher]
	)

	return [state, dispatch, mainDispatcher] as const
}

export default useSyncedReducer
